module.exports = "/_next/static/images/058e472c01d8ede5e71523639af70c2e-cajita.svg";